export default __webpack_public_path__ + "static/media/21782904c4901d9cc65c830b889e7b41.csv";